import $ from 'jquery';
var count = 0;
var srcImg ="";
var title ="";
if ($(window).width()>1000) {
    $('.skill-desc-block__container').each(function () {
        count += 1;
        srcImg = $('#skill-desc-' + count + ' .row .skill-desc-block__icon img').attr('src');
        title = $('#skill-desc-' + count + ' .skill-desc-block__title').text();
        $(".skill-display-contact").before("<a class='skill-display' href='#skill-desc-" + count + "'><div class='container-title'><div class='title-element'>" + title + "</div></div><div class='logo-sticky-element'><img src=" + srcImg + "></div></a>");
    });
}
